// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.margin-30[data-v-7fb0f501] {\n  margin-bottom: 30px;\n}\n", ""]);
// Exports
module.exports = exports;
